var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "position-control",
      class: [
        _vm.expanded ? "expanded" : "",
        _vm.fullscreen ? "fullscreen" : ""
      ]
    },
    [
      _c("VsSliderTP", {
        attrs: {
          value: _vm.position,
          max: _vm.duration,
          minimized: !_vm.expanded
        },
        on: {
          input: _vm.changePosition,
          dragstart: function($event) {
            return _vm.$emit("dragstart", $event)
          },
          dragend: function($event) {
            return _vm.$emit("dragend", $event)
          }
        },
        nativeOn: {
          touchmove: function($event) {
            return _vm.handleMousemove($event)
          },
          touchend: function($event) {
            _vm.hoverPosition = 0
          },
          mousemove: function($event) {
            return _vm.handleMousemove($event)
          },
          mouseleave: function($event) {
            _vm.hoverPosition = 0
          }
        },
        scopedSlots: _vm._u([
          {
            key: "floater",
            fn: function(payload) {
              return _c(
                "div",
                { staticClass: "position-control__hover__floater" },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm._f("toTimeFormat")(payload.value)) +
                      "\n    "
                  )
                ]
              )
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }